import * as React from "react"
import { createPage } from "blog/page"
import { createNavigation } from "blog/components/navigation"
import { JSONRenderer } from "blog/components/json_renderer"
//import { Ukelele } from "blog/components/ukelele"

const page = createPage(createNavigation(), "Home")

export const Home = () => <JSONRenderer json={page} />
//export const Home = () => <Ukelele />
